<div class="modal-header">
  <h4 class="modal-title" id="update-attr-modal-basic-title">
    Detalles del
    {{ archive.__typename === "Driver" ? "Conductor" : "Vehículo" }} Archivado
  </h4>
  <button
    id="cisterna-details-update-attr-modal-close"
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="d('Cross')"
  ></button>
</div>
<div style="padding: 10px" class="table-container">
  <table class="table table-hover">
    <caption>
      Detalles del Vehículo
    </caption>
    <tbody>
      <tr>
        <th class="align-middle" scope="row">Comentario de archivo</th>
        <td>
          <div>
            {{ comment }}
          </div>
        </td>
      </tr>
      <ng-container *ngIf="archive.__typename === 'Driver'">
        <tr>
          <th scope="row">Nombre</th>
          <td>{{ archive.firstName }} {{ archive.lastName }}</td>
        </tr>
        <tr>
          <th scope="row">Correo</th>
          <td>{{ archive.email }}</td>
        </tr>
        <tr>
          <th scope="row">Teléfono</th>
          <td>{{ archive.phone | phone }}</td>
        </tr>
        <tr>
          <th scope="row">Fecha de Nacimiento</th>
          <td>{{ archive.birthDate }}</td>
        </tr>
      </ng-container>
      <tr *ngIf="archive.__typename !== 'Driver'">
        <th scope="row">Patente</th>
        <td>{{ archive.licensePlate }}</td>
      </tr>
      <tr>
        <th scope="row">Fecha de Archivado</th>
        <td>{{ updatedAt | dateFormat | dateWithoutSeconds }}</td>
      </tr>
    </tbody>

    <tbody>
      <tr>
        <th scope="row">Sap Id</th>
        <td>{{ archive.sapId }}</td>
      </tr>
    </tbody>

    <tbody>
      <tr>
        <th scope="row">Trasportista</th>
        <td>{{ archive.carrier!.name }}</td>
      </tr>
      <tr>
        <th scope="row">Centro</th>
        <td>{{ archive.originalCenter! | master : "CENTERS" }}</td>
      </tr>

      <tr *ngIf="archive.__typename !== 'Driver'">
        <th scope="row">Marca</th>
        <td>{{ archive.brand | master : "VEHICLES#BRANDS" }}</td>
      </tr>
      <tr *ngIf="archive.__typename !== 'Driver'">
        <th scope="row">Modelo</th>
        <td>{{ archive.model }}</td>
      </tr>
      <tr *ngIf="archive.__typename !== 'Driver'">
        <th scope="row">Año de Fabricación</th>
        <td>{{ archive.year }}</td>
      </tr>
      <tr *ngIf="archive.__typename !== 'Driver'">
        <th scope="row">Antigüedad</th>
        <td>
          {{ currentYear - archive.year }} año{{
            currentYear - archive.year === 1 ? "" : "s"
          }}
        </td>
      </tr>
      <tr *ngIf="archive.__typename !== 'Driver'">
        <th scope="row">Color</th>
        <td>{{ archive.color | master : "VEHICLES#COLORS" }}</td>
      </tr>
      <tr *ngIf="archive.__typename !== 'Driver'">
        <th scope="row">Tipo</th>
        <td>{{ archive.type | master : "TRACTOS#TYPES" }}</td>
      </tr>
      <tr *ngIf="archive.__typename !== 'Driver'">
        <th scope="row">Motor</th>
        <td>
          {{ archive.engineType! | master : "TRACTOS#ENGINE_TYPES" }}
        </td>
      </tr>
      <tr *ngIf="archive.__typename !== 'Driver'">
        <th scope="row">Capacidad</th>
        <td>
          {{ archive.capacity | master : "TRACTOS#CAPACITIES" }}
        </td>
      </tr>
      <tr *ngIf="archive.__typename !== 'Driver'">
        <th scope="row">Usado en Minería</th>
        <td>{{ archive.forMining ? "Sí" : "No" }}</td>
      </tr>
      <tr *ngIf="archive.__typename !== 'Driver'">
        <th scope="row">Acreditación Ranchera</th>
        <td>{{ archive.hasRanchAccreditation ? "Sí" : "No" }}</td>
      </tr>
      <tr *ngIf="archive.__typename !== 'Driver'">
        <th scope="row">Es Spot</th>
        <td>{{ archive.isSpot ? "Sí" : "No" }}</td>
      </tr>
      <tr *ngIf="archive.__typename !== 'Driver'">
        <th scope="row">GPS IMEI</th>
        <td>{{ archive.gpsImei }}</td>
      </tr>
      <tr *ngIf="archive.__typename !== 'Driver'">
        <th scope="row">Cámara IMEI</th>
        <td>{{ archive.cameraImei }}</td>
      </tr>
      <tr>
        <th class="align-middle" scope="row">Centro de Apoyo</th>
        <td>
          <div>
            {{ archive.center | master : "CENTERS" }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
